export const RECOMMENDATIONS_MANIFEST_INFO_SETTING_KEY = 'recommendationsManifestInfo';

/** Глобальный фича-флаг микрофронтенда рекламного баннера (ad-banner-frontend) */
export const AD_BANNER_MF_ENABLED_KEY = 'MarTech.AdBannerMicrofrontend.Enabled';

/** Ключ настройки с манифестом микрофронтенда рекламного баннера (node -> browser) */
export const AD_BANNER_MF_MANIFEST_SETTING_KEY = 'adBannerMicrofrontendManifest';
